<div class="layout-edit">
  <div class="layout-edit__header">
    <div class="layout-edit__header__title">{{ ui.title }}</div>
  </div>
  <div class="layout-edit__list-group" cdkDropListGroup #listGroup>
    @if (hasAnyFieldsAdded) {
      <div
        class="layout-edit__list-group__column"
        *ngFor="let fieldRow of currentFields; let rowIndex = index; let firstRow = first; let lastRow = last"
        cdkDropList
        [cdkDropListData]="fieldRow"
        (cdkDropListDropped)="dropped($event)"
        cdkDropListOrientation="horizontal"
      >
        <div class="layout-edit__list-group__column__row">
          <div
            class="layout-edit__list-group__column__row__item"
            cdkDrag
            *ngFor="let fieldName of fieldRow; let colIndex = index; let lastCol = last"
          >
            <ng-container
              dynamicFormRow
              [elmType]="'select-field'"
              [baseClassNames]=""
              *ngIf="lookupField(fieldName) as fieldDef; else emptySpace"
            >
              <mat-icon class="drag-handler" svgIcon="drag_indicator" matTooltip="Drag me" cdkDragHandle> </mat-icon>
              <select-field
                class="flex flex-col select-field"
                [enableEmptyField]="true"
                [data]="data"
                [fieldDef]="fieldDef"
                [model]="{}"
                [rowIndex]="rowIndex"
                [colIndex]="colIndex"
                [type]="filterFieldsBy"
                [emptyModel]="true"
                [hasNestedFiltersOn]="hasNestedFiltersOn"
                (update)="onFieldSelectionChange($event, rowIndex, colIndex)"
              >
              </select-field>
              <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Actions">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="after" yPosition="below" class="kanban-icon-menu">
                <button
                  mat-menu-item
                  matTooltip="Remove"
                  matTooltipPosition="left"
                  (click)="removeField(rowIndex, colIndex)"
                >
                  <mat-icon svgIcon="cancel"></mat-icon>
                </button>
                <button mat-menu-item matTooltip="Add" matTooltipPosition="left" (click)="addField(rowIndex)">
                  <mat-icon svgIcon="add_circle"></mat-icon>
                </button>
                <button
                  mat-menu-item
                  matTooltip="Add new row"
                  matTooltipPosition="left"
                  *ngIf="lastCol"
                  (click)="addRow(rowIndex)"
                >
                  <mat-icon svgIcon="library_add"></mat-icon>
                </button>
              </mat-menu>
            </ng-container>
            <ng-template #emptySpace>
              <div class="layout-edit__list-group__column__row__item__empty-space" *ngIf="!lastCol">
                <button mat-button (click)="removeField(rowIndex, colIndex)">
                  <mat-icon svgIcon="cancel"></mat-icon>
                  Remove empty space
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    } @else {
      <div class="layout-edit__list-group__empty">
        <ts-button (click)="addFirstField()">Add field</ts-button>
      </div>
    }
  </div>
  <div class="layout-edit__footer">
    <div class="layout-edit__footer__actions">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!hasChanged">Save</button>
    </div>
  </div>
</div>
